import axios from "@/axios";
import { AxiosResponse } from "axios";
import { CheckSessionResponse } from "@/commons/types";

type LoginParameter = {
  email: string;
  password: string;
};

type LoginResponse = {
  session: string;
};

export function login(arg: LoginParameter): Promise<AxiosResponse<LoginResponse>> {
  return axios.post<LoginResponse>(`/login/`, {
    mail: arg.email,
    password: arg.password,
  });
}
export function logout(): Promise<AxiosResponse<void>> {
  return axios.post(`/logout/`);
}
export function isLogin(): Promise<AxiosResponse<CheckSessionResponse>> {
  return axios.get<CheckSessionResponse>(`/check-session/`);
}
